<template>
  <b-container class="card-container">
    <b-card>
      <template v-slot:header class="card-menu">
        <span class="breadcrumbs"><b-link :to="{name: `${collection}s`}">{{collection | capitalise | pluralise}}</b-link> / Create</span>
      </template>

      <b-form @submit.stop.prevent="create_item">
        <b-form-group label="Sequence Name:" invalid-feedback="Must be greater then 4 character">
          <b-form-input v-model="item.name" required placeholder="Enter sequence name" :state="validate_state('name')"></b-form-input>
        </b-form-group>

        <h4>Email Sender</h4>
        <b-alert :show="!item.sender" variant='warning' class='text-center'>
          <p>You have not connected your account to an email. Please connect before creating a sequence.</p>
          <b-button :to="{name: 'settings'}" variant='warning'>Connect</b-button>
        </b-alert>
        <!-- TODO allow to change -->
        <p v-if="item.sender">{{profile.sending_email.email}}</p>

        <h4>Email Schedule</h4>
        <p>Emails are sent during weekdays between 09:00 and 17:00 in your timezone.</p>
        <!-- <b-badge variant='success' class='mr-1'>Mon</b-badge><b-badge variant='success' class='mr-1'>Tue</b-badge><b-badge variant='success' class='mr-1'>Wed</b-badge><b-badge variant='success' class='mr-1'>Thu</b-badge><b-badge variant='success' class='mr-1'>Fri</b-badge><b-badge variant='dark' class='mr-1'>Sat</b-badge><b-badge variant='dark' class='mr-1'>Sun</b-badge> -->

        <h4>Email Sequence</h4>
        <EmailSequence v-if="!is_saving" :recipient="false" :create="true" :sequence="item" :profile="profile" :steps="item.steps" :from_email="profile.sending_email ? profile.sending_email.email : ''" style='max-width: 720px;'/>

        <LoadingButton v-if='item.sender' type="submit" variant='primary' :loading="is_saving">Save</LoadingButton>
      </b-form>
    </b-card>
  </b-container>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators"
import ItemMixin from "@/mixins/Item.js"
import { db, FieldValue } from '@/main.js'
import EmailSequence from '@/components/EmailSequence'

export default {
  metaInfo: {title: 'Sequence create'},
  mixins: [ItemMixin],
  components: {EmailSequence},
  validations: {
    item: {
      name: {required, minLength: minLength(3)},
    }
  },
  firestore: function () {
    return {
      _item: db.collection(this.collection).doc()
    }
  },
  data() {
    let sender = null
    if (this.profile.sending_email) {
      sender = db.collection('team').doc(this.profile.team.id).collection('email').doc(this.profile.sending_email.id)
    }

    return {
      collection: 'sequence',
      item: {
        name: '',
        status: 'running',
        sender: sender,
        steps: [{days_delay: 0, subject: 'Subject', body: '', type: 'email'}],
        total: 0,
        started: 0,
        finished : 0,
        paused: 0,
        active: 0,
        replied: 0,
        bounced: 0,
        unsubscribed: 0,
        auto_replied: 0,
      },
    }
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'sequence') {
      next()
      return
    }

    const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
    if (answer) {
      next()
    } else {
      next(false)
    }
  },
  methods: {
    async do_before() {
      let steps = []
      let proms = []
      for (let step of this.item.steps) {
        let item_doc = this.$firestoreRefs._item.collection('step').doc()
        proms.push(item_doc.set({
          updated: new Date(),
          created: new Date(),
          user: db.collection('user').doc(this.profile.id),
          uid: this.profile.id,
          team: db.collection('team').doc(this.profile.team.id),
          type: 'email',
          days_delay: step.days_delay,
          subject: step.subject,
          body: step.body,
          sent: 0,
          opened: 0,
          replied: 0,
          clicked: 0,
          bounced: 0,
          unsubscribed: 0,
          auto_replied: 0
        }))

        steps.push(item_doc)
      }

      let item_doc = this.$firestoreRefs._item.collection('step').doc()
      proms.push(item_doc.set({
        updated: new Date(),
        created: new Date(),
        user: db.collection('user').doc(this.profile.id),
        uid: this.profile.id,
        team: db.collection('team').doc(this.profile.team.id),
        days_delay: 5, // TODO
        type: 'finish',
      }))

      steps.push(item_doc)

      await Promise.all(proms)

      this.item.steps = steps

      return true
    },
    async do_after() {
      await db.collection('user').doc(this.profile.id).update({updated: new Date(), sequences_count: FieldValue.increment(1)})
    }
  }
}
</script>

<style>

</style>
